"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSiteControlWidget = exports.nationwideDistance = exports.DRIFTROCK_API_KEY = exports.reCAPTCHAv2PublicKey = exports.categoryToFormattedCategoryMap = exports.Modal = exports.LocalStorageKey = exports.UrlParameter = exports.UrlAction = exports.FacetType = exports.GtmEvents = exports.FORM_COOKIE_EXPIRE_TIME = exports.Pages = exports.STATIC_PAGES_PATH = exports.Form = exports.Stage = exports.CategoryUrlName = void 0;
var CategoryUrlName;
(function (CategoryUrlName) {
    CategoryUrlName["UsedCars"] = "used-cars";
    CategoryUrlName["Motorbikes"] = "motorbikes";
    CategoryUrlName["BigStuff"] = "big-stuff";
    CategoryUrlName["Motorsport"] = "motorsport";
    CategoryUrlName["PartsAndPlates"] = "parts-and-plates";
    CategoryUrlName["NonMotoring"] = "non-motoring";
})(CategoryUrlName = exports.CategoryUrlName || (exports.CategoryUrlName = {}));
var Stage;
(function (Stage) {
    Stage["Dev"] = "dev";
    Stage["Test"] = "test";
    Stage["Qa"] = "qa";
    Stage["Prod"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
var Form;
(function (Form) {
    Form["ContactSeller"] = "contact-seller-form";
    Form["InternalLeadsListingForm"] = "leads-refresh-form";
    Form["InternalLeadsSubmitForm"] = "leads-submit-form";
    Form["Newsletter"] = "newsletter";
    Form["ReportAd"] = "report-ad-form";
    Form["Srp"] = "srp-form";
})(Form = exports.Form || (exports.Form = {}));
exports.STATIC_PAGES_PATH = '/static-pages/[deviceType]/[variant]';
var Pages;
(function (Pages) {
    Pages["BuyPage"] = "buy/[...facets]";
    Pages["Error"] = "error";
    Pages["FeaturesArticle"] = "features/[subCategory]/[headline]/[articleId]";
    Pages["FeaturesLandingPage"] = "features";
    Pages["FeaturesSubCategoryLandingPage"] = "features/[subCategory]";
    Pages["Homepage"] = "";
    Pages["NewsArticle"] = "news/[subCategory]/[headline]/[articleId]";
    Pages["NewsLandingPage"] = "news";
    Pages["NewsSubCategoryLandingPage"] = "news/[subCategory]";
    Pages["NotFound"] = "not-found";
    Pages["PrivacyAndPolicy"] = "privacy-policy";
    Pages["PricingPolicy"] = "pricing-policy";
    Pages["RegularsArticle"] = "regulars/[subCategory]/[headline]/[articleId]";
    Pages["RegularsLandingPage"] = "regulars";
    Pages["RegularsSubCategoryLandingPage"] = "regulars/[subCategory]";
    Pages["RoadTestsArticle"] = "road-tests/[subCategory]/[headline]/[articleId]";
    Pages["RoadTestsLandingPage"] = "road-tests";
    Pages["RoadTestsSubCategoryLandingPage"] = "road-tests/[subCategory]";
    Pages["SearchResultsPage"] = "buy/search";
    Pages["SearchLandingPage"] = "buy/cars/[searchLandingPage]";
    Pages["ServiceUnavailable"] = "service-unavailable";
    Pages["Support"] = "support";
    Pages["TermsAndConditions"] = "terms-and-conditions";
    Pages["UnfurledAdvertPage"] = "internal/unfurled-ad/[unfurledAdvertId]";
    Pages["VehicleDetailsPage"] = "buy/listing/[advertId]";
})(Pages = exports.Pages || (exports.Pages = {}));
exports.FORM_COOKIE_EXPIRE_TIME = 30;
var GtmEvents;
(function (GtmEvents) {
    GtmEvents["ReactDataLayerPush"] = "gtm.react";
    GtmEvents["SpaPageView"] = "spa-page-view";
    GtmEvents["SetupOptimize"] = "setup-optimize";
})(GtmEvents = exports.GtmEvents || (exports.GtmEvents = {}));
var FacetType;
(function (FacetType) {
    FacetType["Year"] = "year";
    FacetType["Colour"] = "colour";
    FacetType["FuelType"] = "fuel";
    FacetType["MakeName"] = "makeName";
    FacetType["ModelName"] = "modelName";
})(FacetType = exports.FacetType || (exports.FacetType = {}));
var UrlAction;
(function (UrlAction) {
    UrlAction["FavouriteAdvert"] = "favourite-advert";
    UrlAction["SaveSearch"] = "save-search";
})(UrlAction = exports.UrlAction || (exports.UrlAction = {}));
var UrlParameter;
(function (UrlParameter) {
    UrlParameter["Action"] = "action";
    UrlParameter["AdvertToFavourite"] = "advert-to-favourite";
    UrlParameter["VdpCarouselIds"] = "cId";
    UrlParameter["SortBy"] = "sort-by";
})(UrlParameter = exports.UrlParameter || (exports.UrlParameter = {}));
var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["ArticleRating"] = "article-rating";
    LocalStorageKey["CarRaterTenPoint"] = "car-rater";
})(LocalStorageKey = exports.LocalStorageKey || (exports.LocalStorageKey = {}));
var Modal;
(function (Modal) {
    Modal["ContactSeller"] = "contactSeller";
    Modal["Error"] = "error";
    Modal["NotLoggedIn"] = "notLoggedIn";
    Modal["Postcode"] = "postcode";
    Modal["ReportAd"] = "reportAd";
    Modal["SearchForm"] = "searchForm";
    Modal["Filter"] = "filter";
})(Modal = exports.Modal || (exports.Modal = {}));
exports.categoryToFormattedCategoryMap = {
    [CategoryUrlName.UsedCars]: 'Used cars',
    [CategoryUrlName.BigStuff]: 'Big stuff',
    [CategoryUrlName.Motorbikes]: 'Motorbikes',
    [CategoryUrlName.Motorsport]: 'Motorsport',
    [CategoryUrlName.NonMotoring]: 'Non-motoring',
    [CategoryUrlName.PartsAndPlates]: 'Parts and plates',
};
exports.reCAPTCHAv2PublicKey = process.env.STAGE === 'prod'
    ? '6LeszPoeAAAAAI5rTfUEstQQSuWDVAndt1uQWqD7'
    : '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
exports.DRIFTROCK_API_KEY = 'bea7f935-ac93-4ef9-99fc-6ed923935b84';
exports.nationwideDistance = '2147483647';
var GetSiteControlWidget;
(function (GetSiteControlWidget) {
    GetSiteControlWidget[GetSiteControlWidget["VdpLeadSubmit"] = 489751] = "VdpLeadSubmit";
})(GetSiteControlWidget = exports.GetSiteControlWidget || (exports.GetSiteControlWidget = {}));
//# sourceMappingURL=constants.js.map